// extracted by mini-css-extract-plugin
export default {"grid":"UserGroupParticipants_grid__sIpQl"};